import React, { useState, useImperativeHandle, forwardRef } from 'react';
import { Snackbar } from 'react-native-paper';
import { ToastOptions, ToastType } from '../services/toastService';

interface ToastState extends ToastOptions {
  visible: boolean;
}

export const ToastProvider = forwardRef((props, ref) => {
  const [toast, setToast] = useState<ToastState>({
    visible: false,
    message: '',
    type: 'info',
    duration: 3000,
  });

  useImperativeHandle(ref, () => ({
    show: (options: ToastOptions) => {
      setToast({
        visible: true,
        message: options.message,
        type: options.type || 'info',
        duration: options.duration || 3000,
        action: options.action,
      });
    },
  }));

  const handleDismiss = () => {
    setToast(prev => ({ ...prev, visible: false }));
  };

  const getBackgroundColor = (type: ToastType) => {
    switch (type) {
      case 'success':
        return '#4CAF50';
      case 'error':
        return '#F44336';
      case 'warning':
        return '#FF9800';
      case 'info':
      default:
        return '#2196F3';
    }
  };

  return (
    <Snackbar
      visible={toast.visible}
      onDismiss={handleDismiss}
      duration={toast.duration}
      action={toast.action}
      style={{
        backgroundColor: getBackgroundColor(toast.type || 'info'),
      }}
    >
      {toast.message}
    </Snackbar>
  );
});